<div class="token-composer">
    @if (isToken()) {
        <div
            class="token-chip"
            [class.empty]="isEmpty()"
            [raTooltip]="isEmpty() ? { text: ('shared.editor.dataTagEmpty' | translate), position: 'top' } : null"
        >
            <span class="token-chip-label">{{ chipLabel() }}</span>
            <button
                type="button"
                class="token-chip-remove"
                [disabled]="disabled()"
                (click)="removeToken()"
                [attr.aria-label]="'common.remove' | translate"
            >
                <ra-icon icon="close" varColor="currentColor" [size]="14" />
            </button>
        </div>
    } @else {
        <div class="token-input-wrapper">
            <input
                type="text"
                class="token-input"
                [value]="draft()"
                [attr.maxlength]="limitChar() || null"
                [placeholder]="placeholder()"
                [disabled]="disabled()"
                (input)="onInput($event)"
                (keydown)="onKeydown($event)"
                (blur)="onBlur()"
            />

            @if (showAutocomplete()) {
                <div class="autocomplete-overlay">
                    <div class="autocomplete-list">
                        @for (group of filteredLinksByCategory(); track group.categoryDescription) {
                            <div class="autocomplete-category">
                                <span class="autocomplete-category-label">{{ group.categoryDescription }}</span>
                                @for (item of group.items; track item.link.tagName + (item.link.value ?? '')) {
                                    <button
                                        type="button"
                                        class="autocomplete-item"
                                        [class.selected]="item.flatIndex === autocompleteIndex()"
                                        (mousedown)="selectLink(item.link); $event.preventDefault()"
                                    >
                                        <ra-icon
                                            class="autocomplete-icon"
                                            [icon]="getLinkIcon(item.link)"
                                            [size]="18"
                                            varColor="contentTertiary"
                                        />
                                        <span class="autocomplete-value">{{
                                            getLinkLabel(item.link)
                                        }}</span>
                                    </button>
                                }
                            </div>
                        }
                        @empty {
                            <div class="autocomplete-empty">{{ 'shared.editor.noLinksFound' | translate }}</div>
                        }
                    </div>
                </div>
            }
        </div>

        @if (limitChar()) {
            <span class="token-counter" [class.exceeded]="draft().length > limitChar()">
                {{ draft().length }}/{{ limitChar() }}
            </span>
        }
    }
</div>
